var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24145 8.0825L5.58444 4.4255C5.51136 4.35894 5.45237 4.27839 5.41096 4.18863C5.36956 4.09887 5.34659 4.00171 5.3434 3.90291C5.34022 3.80411 5.35689 3.70568 5.39242 3.61343C5.42796 3.52119 5.48164 3.43702 5.55029 3.36589C5.61894 3.29476 5.70116 3.23813 5.79209 3.19935C5.88302 3.16057 5.9808 3.14043 6.07965 3.14011C6.1785 3.13979 6.27641 3.15931 6.36759 3.19751C6.45876 3.23571 6.54134 3.29181 6.61044 3.3625L6.62844 3.3805L10.8084 7.5595C10.947 7.69808 11.0248 7.88603 11.0248 8.082C11.0248 8.27797 10.947 8.46591 10.8084 8.6045L6.62945 12.7835C6.56201 12.8533 6.48149 12.9091 6.39248 12.9478C6.30347 12.9865 6.20771 13.0073 6.11067 13.0089C6.01364 13.0106 5.91722 12.9931 5.82693 12.9575C5.73664 12.922 5.65424 12.8689 5.58445 12.8015C5.51465 12.7341 5.45882 12.6535 5.42014 12.5645C5.38146 12.4755 5.36069 12.3798 5.35902 12.2827C5.35735 12.1857 5.37481 12.0893 5.4104 11.999C5.44599 11.9087 5.49901 11.8263 5.56645 11.7565L5.58445 11.7385L9.24145 8.0825Z",
    fill: "#EF3A5E",
    stroke: "#EF3A5E",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.6de0e49dcf1ad055ac91d78d9cf3a2d3.svg";
export { ForwardRef as ReactComponent };